export default __webpack_public_path__ + "static/media/logo.b79f2333.jpg";